import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import SvgIcon from '@components/SvgIcon'

type AnswerHeaderProps = {
  title: string
  isLoading?: boolean
}

const StyledAnswerHeader = styled.div`
  ${({
    theme: {
      spacing: { spacing24, spacing16 },
    },
  }) => css`
    display: flex;
    align-items: center;
    margin-bottom: ${spacing24};

    ${mobileCSS(css`
      margin-bottom: ${spacing16};
    `)}
  `}
`

const StyledIconWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    margin-right: ${spacing8};
    width: 32px;
    height: 32px;
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
  `}
`

const StyledBackground = styled.div<{ isLoading?: boolean }>`
  ${({
    theme: {
      colors: { fillBrand },
    },
    isLoading,
  }) => css`
    position: absolute;
    z-index: -1;

    width: 32px;
    height: 32px;

    background-color: ${fillBrand};
    border-radius: 48px;

    @keyframes zoomInOut {
      // start at 20% to have a 200ms delay before the animation starts
      20% {
        transform: scale(1);
      }

      60% {
        transform: scale(1.25);
      }

      100% {
        transform: scale(1);
      }
    }

    ${isLoading &&
    css`
      animation: zoomInOut 1000ms ease-in-out infinite;
    `}
  `}
`

const StyledTitle = styled.div`
  ${({
    theme: {
      typography: {
        headings: { small: smallHeadingCSS },
      },
      utils: { ellipsis },
    },
  }) => css`
    ${smallHeadingCSS};
    flex: 1;

    ${ellipsis('100%', 3)}
  `}
`

const AnswerHeader: FunctionComponent<AnswerHeaderProps> = ({
  title,
  isLoading,
}) => {
  const theme = useTheme()

  return (
    <StyledAnswerHeader>
      <StyledIconWrapper>
        <StyledBackground isLoading={isLoading} />
        <SvgIcon iconName="stars" size={20} color={theme.colors.staticWhite} />
      </StyledIconWrapper>
      <StyledTitle>{title}</StyledTitle>
    </StyledAnswerHeader>
  )
}

export default AnswerHeader
